angular.module "colorpicker.setting", [
  "minicolors",
  "color.setting"
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/color/main.coffee